// Affichage des heures dans le fuseau choisi par le visiteur (sélecteur), avec
// rappel de l'heure du commerçant (tenant) quand les deux diffèrent.
// Les créneaux sont des instants absolus (slot.start, ISO avec décalage) :
// on les formate à la volée, sans jamais changer ce qui est réservé.
import { formatTimeInZone, zoneCity } from "./timezone.js";

/** Heure principale d'un créneau, dans le fuseau d'affichage. */
export function slotTime(slot, displayTz) {
  return formatTimeInZone(slot.start, displayTz) || slot.label;
}

/**
 * Note d'un bouton de créneau : « Disponible », ou
 * « Disponible · 09:00 à Guadeloupe » quand on affiche dans un autre fuseau
 * que celui du commerçant.
 */
export function slotAvailabilityNote(slot, displayTz, tenantTz, messages) {
  if (!tenantTz || !displayTz || displayTz === tenantTz) {
    return messages.slotAvailable;
  }
  const businessTime = formatTimeInZone(slot.start, tenantTz);
  if (!businessTime || businessTime === slotTime(slot, displayTz)) {
    return messages.slotAvailable;
  }
  return `${messages.slotAvailable} · ${businessTime} ${messages.tzAt} ${zoneCity(tenantTz)}`;
}

/**
 * Heure d'un créneau choisi/confirmé, avec l'équivalent commerçant si différent :
 * « 15:00 » ou « 15:00 — 09:00 heure de Guadeloupe ».
 */
export function slotTimeWithZones(slot, displayTz, tenantTz, messages) {
  const main = slotTime(slot, displayTz);
  if (!tenantTz || !displayTz || displayTz === tenantTz) {
    return main;
  }
  const businessTime = formatTimeInZone(slot.start, tenantTz);
  if (!businessTime || businessTime === main) {
    return main;
  }
  return `${main} — ${businessTime} ${messages.tzHourOf} ${zoneCity(tenantTz)}`;
}
